import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
export function App() {
  return <Router data-id="element-0" data-mp="2mnnge4e0wc1a">
      <ScrollToTop data-id="element-1" data-mp="2mjzlp1wudjkz" />
      <div className="flex flex-col min-h-screen" data-id="element-2" data-mp="31agoaol7qfjg">
        <TopBar data-id="element-3" data-mp="31c9u61o04vqe" />
        <Navbar data-id="element-4" data-mp="31ctf7r8y808n" />
        <main className="flex-grow" data-id="element-5" data-mp="2wk0bn6p7uxy5">
          <Routes data-id="element-6" data-mp="2wiywaq163pam">
            <Route path="/" element={<HomePage data-id="element-8" data-mp="2wi5n7ieqknpb" />} data-id="element-7" data-mp="2wifgpfyzpczr" />
            <Route path="/about" element={<AboutPage data-id="element-10" data-mp="28te3zgj4jfoo" />} data-id="element-9" data-mp="28u5vaf5our95" />
            <Route path="/services" element={<ServicesPage data-id="element-12" data-mp="23vkvuhy9gblr" />} data-id="element-11" data-mp="28sl0cofgp6ar" />
            <Route path="/contact" element={<ContactPage data-id="element-14" data-mp="23v2td3l0915e" />} data-id="element-13" data-mp="23u9v6r043jyv" />
            <Route path="/portal" element={<ComingSoonPage data-id="element-16" data-mp="3iiwdijzxza14" />} data-id="element-15" data-mp="3ijxsv0nzqion" />
          </Routes>
        </main>
        <Footer data-id="element-17" data-mp="3mlj8uuvtnd32" />
      </div>
    </Router>;
}